import { useMemo } from 'react';
import { useLang } from '../../../../../hooks/use-lang';
import { DashboardCardDataType } from '../../../../../store/api/dashboard-api';
import { DashboardCardProps } from '../dashboard-components/dashboard-cards/dashboard-card/dashboard-card';
import { bestWaiterDefaults, totalOrdersDefaults } from './dashboard-menu-consts';

export const useDashboardMenuCards = (cards?: DashboardCardDataType) => {
  const { t, getLocale } = useLang();

  const totalOrders: DashboardCardProps = useMemo(() => {
    if (cards?.orders) {
      return {
        ...totalOrdersDefaults,
        content: `${cards.orders} ${t('шт')}`,
      };
    }

    return {
      ...totalOrdersDefaults,
      content: '0',
    };
  }, [cards, t]);

  const bestWaiter: DashboardCardProps = useMemo(() => {
    if (cards?.waiter) {
      return {
        ...bestWaiterDefaults,
        content: getLocale(cards.waiter),
      };
    }

    return {
      ...bestWaiterDefaults,
      content: '',
    };
  }, [cards]);

  return [totalOrders, bestWaiter];
};
